import { AiSkillsRoute, LazyPage, SkillsPage } from './-components';
import { createFileRoute } from '@tanstack/react-router';

function SkillsIndexRoute() {
  return (
    <AiSkillsRoute>
      <LazyPage>
        <SkillsPage />
      </LazyPage>
    </AiSkillsRoute>
  );
}

export const Route = createFileRoute('/_authenticated/workspaces/$workspaceId/agent/skills/')({
  component: SkillsIndexRoute,
});
